import React, { useEffect, useState } from "react";
import styled from "styled-components";

const calculateTimeLeft = () => {
  const countdownDate = new Date("Apr 10, 2021 14:00:00").getTime();
  const currentDate = new Date().getTime();
  const difference = countdownDate - +currentDate;
  let timeLeft = {};
  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }
  return timeLeft;
};

const padToTwo = (number) => (number <= 99 ? `0${number}`.slice(-2) : number);

const Timer = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  return (
    <Stopwatch>
      <LeftHinge />
      <p>YOUR EVENT BEGINS IN</p>
      <Time>
        <div>
          {padToTwo(timeLeft.days)}
          <small>DAYS</small>
        </div>
        <span>:</span>
        <div>
          {padToTwo(timeLeft.hours)}
          <small>HOURS</small>
        </div>
        <span>:</span>
        <div>
          {padToTwo(timeLeft.minutes)}
          <small>MINS</small>
        </div>
      </Time>
      <RightHinge />
    </Stopwatch>
  );
};

const Time = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  letter-spacing: 0.1em;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    small {
      font-size: 0.25em;
      letter-spacing: 1px;
      font-weight: 600;
    }
  }
  span {
    animation: blink 1s infinite;
    font-size: 0.8em;
    line-height: 1.5em;
    align-self: flex-start;
  }
  @media (min-width: 768px) {
    font-size: 3rem;
  }
  @keyframes blink {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

const LeftHinge = styled.div`
  width: 20px;
  height: 20px;
  border-left: 20px solid transparent;
  border-bottom: 20px solid #71323b;
  position: absolute;
  top: 0;
  left: -20px;
`;

const RightHinge = styled.div`
  width: 20px;
  height: 20px;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #71323b;
  position: absolute;
  top: 0;
  right: -20px;
`;

const Stopwatch = styled.div`
  background: var(--abbvie-red);
  color: white;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 0.5rem;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
  position: relative;
  p {
    font-weight: 700 !important;
    font-size: 0.875rem !important;
    color: white;
    letter-spacing: 0;
    text-transform: uppercase;
    text-align: center;
  }
  @media (min-width: 768px) {
    padding: 1rem;
    p {
      font-size: 1rem !important;
    }
  }
`;

export default Timer;
